import DEFAULT_POSITION from '../defaultPosition';
import getDefaultAlign from './getDefaultAlign';

var getModifiers = function getModifiers(_ref) {
  var _ref2;

  var align = _ref.align,
      position = _ref.position,
      sameWidth = _ref.sameWidth;
  var finalPosition = position || DEFAULT_POSITION;

  var _finalPosition$split = finalPosition.split(' '),
      verticalPosition = _finalPosition$split[0],
      horizontalPosition = _finalPosition$split[1];

  var _split = (align || getDefaultAlign(finalPosition)).split(' '),
      verticalAlign = _split[0],
      horizontalAlign = _split[1];

  return _ref2 = {}, _ref2["&position-" + horizontalPosition] = true, _ref2["&position-" + verticalPosition] = true, _ref2["&align-" + horizontalAlign] = true, _ref2["&align-" + verticalAlign] = true, _ref2['&sameWidth'] = !!sameWidth, _ref2;
};

export default getModifiers;